let parameters = {
    tableDataSource: {
        label: 'Table Data',
        class: 'xs12 sm12 d-flex',
        type: 'select',
        source: 'dataSources',
        itemValue: 'id',
        itemText: 'name',
        items: [],
        item: {data: [], headers: []},
        wait: false
    },
    template: {
        label: 'Template',
        source: 'parameters.never',
        items: [],
        types: [],
        item: {data: [], headers: []},
        class: 'xs12 sm12 d-flex',
        type: 'textarea',
        value: '',
        display: false,
        wait: false
    }
};

export default parameters;
